import { IonPage, IonContent } from '@ionic/react';
import { useIsMobile } from '../hooks/useMediaQuery';

export function ResourceLibraryPage() {
  const isMobile = useIsMobile();

  return (
    <IonPage>
      <IonContent className="page-content bg-gray-50">
        <div className={`page-header ${isMobile ? 'page-header-mobile' : 'page-header-desktop'}`}>
          <div className="title">Resource Library</div>
        </div>
      </IonContent>
    </IonPage>
  );
}

